import React from 'react';
import PropTypes from 'prop-types';

import {Tile} from 'pac-ux-components';

import {Center, Grid, Stack, useMantineTheme} from '@mantine/core';

import {SmallProfileOverflowMenu} from './SmallProfileOverflowMenu';

import {UserAvatar} from './UserAvatar';
import {UserFullName} from './UserFullName';
import {useMediaQuery} from '@mantine/hooks';

export const SmallProfile = ({
                                 account,
                                 onClick,
                                 onSignOut,
                                 onSignOutAndForget,
                                 onHideAccount,
                             }) => {
    const theme = useMantineTheme();

    const lessThanMedium = useMediaQuery(
        `(max-width: ${theme.breakpoints.md}px)`
    );


    return (
        <Tile className="cursor-pointer">
            <Grid gutter="sm" p="xs">
                <Grid.Col
                    sm={12}
                    md={3}
                    onClick={onClick}
                    className="cursor-pointer"
                >
                    <Center>
                        <UserAvatar user={account} width="50" height="50"/>
                    </Center>
                </Grid.Col>

                <Grid.Col
                    xs={10}
                    md={7}
                    onClick={onClick}
                    className="cursor-pointer"
                >
                    <Stack
                        spacing="xs"
                        mt="sm"
                        align={lessThanMedium ? 'center' : 'left'}
                    >
                        <UserFullName user={account}/>
                        {account['emailAddress']}
                    </Stack>
                </Grid.Col>

                <Grid.Col xs={2} md={2}>
                    <Center mt="md">
                        <SmallProfileOverflowMenu
                            onSignOut={onSignOut}
                            onSignOutAndForget={onSignOutAndForget}
                            onHideAccount={onHideAccount}
                        />
                    </Center>
                </Grid.Col>
            </Grid>
        </Tile>
    );
};

SmallProfile.propTypes = {
    account: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    onSignOut: PropTypes.func,
    onSignOutAndForget: PropTypes.func,
    onHideAccount: PropTypes.func,
};
